/**
 * @file Axios HTTPクライアントの共通設定
 *
 * BFF（Backend For Frontend）へのリクエストに使用されるAxiosインスタンス。
 * ベースURLの設定、リクエストヘッダーの共通設定、
 * エラーハンドリングのインターセプターを設定している。
 * ※SigV4署名付きAPI呼び出しはcognito.tsから直接axiosを使用する。
 */
import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import { ApiUrl } from './constants';

/** BFFのAPIドメイン（環境変数から取得） */
const baseURL = ApiUrl.DOMAIN;

/** 共通設定済みのAxiosインスタンス */
const instance = axios.create({
  baseURL,
});

// リクエストインターセプター: 全リクエストにContent-Type: application/jsonを付与
instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  let { headers } = config;
  if (headers) {
    headers['content-type'] = 'application/json';
  } else {
    headers = new AxiosHeaders({ 'content-type': 'application/json' });
  }
  return config;
});

// レスポンスインターセプター: エラー時はそのまま例外をスローし、呼び出し元でハンドリングさせる
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    throw error;
  }
);

export default instance;
